<template>
    <div id="app">
        <div class="main">
            <transition name="top" mode="out-in">
                <component :is="gameRun"></component>
            </transition>
        </div>
 
        <Footer />
        <!-- Modal -->
        <Modal name="infoModal" type="normal">
            <span slot="title">O'yin haqida</span>
            <span slot="text">
                Ushbu o'yin orqali bilgan va bilmaganlaringizni mustahkamlab, bilib olishingizga tilakdoshmiz. 
                Tez orada o'yinda shaxsiy profilingizni ochishingiz mumkin.
                O'yinni profilingiz bilan o'ynasangiz rekordlar jadvalida birinchilikni qo'lga kiritishingiz mumkin.
                Ushbu o'yin brauzer o'yinlar guruxiga mansub o'yin hisoblanadi.
                <br>O'yin test rejimida ishlamoqda! Agarda biron bir xato topsangiz murojaat qilishingizni so'raymiz:
                <br>Tuzdi: Full stack dasturchi <a href="https://t.me/raupov_manuchehr" class="link">Raupov Manuchehr</a>
            </span>
        </Modal>
    </div>
</template>

<script>
import Modal from "./components/Modal.vue";
import Footer from "./components/include/footer.vue";
import Welcome from "./components/Welcome.vue";
import GamePlay from "./components/GamePlay.vue";
import {mapGetters} from "vuex";

export default {
    name: 'App',

    components: {
        Modal: Modal,
        Footer: Footer,
        Welcome: Welcome,
        GamePlay: GamePlay
    },

    computed: {
        ...mapGetters([
            "game"
        ]),

        gameRun() {
            return this.game.running ? GamePlay : Welcome
        }
    }

}
</script>

<style lang="scss">
@import "./styles/main";
@import "./styles/fonts";
@import "./styles/transitions";
@import "./assets/Fontawesome/css/all.css";
@import "./assets/Fontawesome/css/v4-shims.min.css";
</style>
